const getApi = <T>(url: string): Promise<T> => {
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Accept', 'application/json')
  return fetch(url, { headers })
    .then(response => {
      if (!response.ok) {
        throw new Error(response.statusText)
      }
      return response.json() as Promise<T>
    })
    .then(data => { /* <-- data inferred as { data: T } */
      return data
    })
}

const postApi = <T, K>(params: K): Promise<T> => {
  const query = '/de/api'
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  const mode = 'cors'
  const cache = 'no-cache'
  const redirect = 'follow'
  const body = JSON.stringify(params)
  // Create init parameters for request
  const init: RequestInit = {
    method: 'post',
    headers,
    mode,
    body,
    cache,
    redirect
  }

  const request = new Request(query, init)

  return fetch(request)
    .then(response => {
      if (!response.ok) {
        throw new Error(response.statusText)
      }
      return response.json() as Promise<T>
    })
    .then(data => { /* <-- data inferred as { data: T } */
      return data
    })
}

export { getApi, postApi }
